<template>
<div class='frame' @mousemove='move'>
  <div class='track' ref='track' >
    <div class='pointer one' id='one' ref='one' :style='cssVars' @mousedown='startMoving'
    @mouseup='stopMoving' draggable='false' ondragstart="return false;"></div>
    <div class='pointer two' id='two' ref='two' :style='cssVars' @mousedown='startMoving'
    @mouseup='stopMoving' draggable='false' ondragstart="return false;"></div>
  </div>
</div>
</template>
<script>

import Vue from 'vue';


export default {
  name: "DoubleSlider",
  data() {
    return {
      pointerPercent: {
        one: 0,
        two: 100,
      }
    }
  },
  mounted() {
    this.track = document.querySelector('.track').getBoundingClientRect();

  },

  computed: {

    cssVars() {
      return {
        '--pointer-one-percent': this.pointerPercent.one  + '%',
        '--pointer-two-percent': this.pointerPercent.two  + '%',
      }
    }
  },

  methods: {

    startMoving(e) {
      e.target.moving = true;
      e.target.start = e.pageX - e.target.parentElement.getBoundingClientRect().left;
      e.target.startPercent = this.pointerPercent[e.target.id];
      e.target.style.backgroundColor = 'whitesmoke';
    },

    stopMoving(e) {
      e.target.moving = false;
      e.target.style.backgroundColor = 'white';
    },

    move(e) {
      const parentBox = this.$refs.track.getBoundingClientRect();
      const handleIds = ['one', 'two'];
      handleIds.forEach(handleId => {
        if (this.$refs[handleId].moving === true) {
          const target = this.$refs[handleId];
          const currentX = e.pageX - parentBox.left - target.start;
          const percent = 100 * currentX / parentBox.width;
          let newPercent = target.startPercent + percent;
          if (newPercent > 100) newPercent = 100;
          if (newPercent < 0) newPercent = 0;
          if (handleId === 'one') {
            if (newPercent > this.pointerPercent.two) newPercent = this.pointerPercent.two
          }
          if (handleId === 'two') {
            if (newPercent < this.pointerPercent.one) newPercent = this.pointerPercent.one
          }
          Vue.set(this.pointerPercent, target.id, newPercent);
          this.$emit('handle-'+target.id, this.pointerPercent[target.id] / 100)
        }
      })

    },
  },
}
</script>
<style scoped>

.frame {
  width: 85%;
  display: grid;
}

.track {
  width: 100%;
  height: 5px;
  background-color: black;
  border-style: inset;
  border-width: 1px;
  border-radius: 5px;
  position: relative}

.pointer {
  position: absolute;
  top: -6px;
  width: 15px;
  height: 15px;
  background-color: white;
  border-radius: 16px;
  border: 1px solid grey;
  cursor: pointer;
}

.one {
  left: calc(var(--pointer-one-percent) - 8px);
  z-index: 0;

}

.two {
  left: calc(var(--pointer-two-percent) - 8px);
  z-index: 1;
}
</style>
